export const ANNOTATIONS_FEATURE_KEY = 'annotations';
export const CPMM_UI_FEATURE = 'cpmm_ui';
export const WORKFLOW_FEATURE_KEY = 'workflow';
export const TASKS_FEATURE_KEY = 'tasks';
